

export const LiqpayRadio = () => {

    return (
        <div className="form-check">
            <input className="form-check-input" type="radio" name="pay-methods" value='liqpay' id="liqpay"/>
            <label className="form-check-label fs-6 fw-bold" htmlFor="liqpay">
                LiqPay - онлайн оплата
            </label>
        </div>
    )
}